import React, { ChangeEvent } from 'react'
import styles from '~/styles/atoms/textarea/textarea.module.scss'

import { TEXT_STRING_MAX_LENGTH } from '~/common/define/parameters'
import { addClass } from '~/common/utils/html'

interface Props {
  name?: string
  value: string
  onChange(event: ChangeEvent<HTMLTextAreaElement>): void
  onBlur?(event: ChangeEvent<HTMLTextAreaElement>): void
  maxLength?: number
  placeholder?: string
  autoComplete?: string
  autoFocus?: boolean
  rows?: TextAreaRow|number
  error?: boolean
}

export enum TextAreaRow {
  MIN = 1,
  NORMAL = 2,
  WIDE = 4
}

const TextArea = ({
                    name = "",
                    value,
                    onChange,
                    onBlur = null,
                    maxLength = TEXT_STRING_MAX_LENGTH,
                    placeholder = '',
                    autoComplete = 'off',
                    autoFocus = false,
                    rows = TextAreaRow.NORMAL,
                    error = false
                  }: Props) => {
  return (
    <textarea
      className={styles.textarea + addClass(styles.error, error)}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      maxLength={maxLength}
      placeholder={placeholder}
      autoComplete={autoComplete}
      autoFocus={autoFocus}
      rows={rows}
    />
  )
}

export default TextArea
